import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/asignacion-de-seguridad-social/';

/**
 * GET tipo de Seguridad Social Asignacion
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSeguridadSocialAsignaciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET tipo de Seguridad Social Asignacion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSeguridadSocialAsignacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST tipo de Seguridad Social Asignacion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSeguridadSocialAsignacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH tipo de Seguridad Social Asignacion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSeguridadSocialAsignacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE tipo de Seguridad Social Asignacion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSeguridadSocialAsignacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR tipo de Seguridad Social Asignacion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarSeguridadSocialAsignacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
